import i from "./index.es267.js";
import m from "./index.es144.js";
import u from "./index.es419.js";
import h from "./index.es420.js";
import w from "./index.es263.js";
import b from "./index.es147.js";
import S from "./index.es158.js";
import g from "./index.es260.js";
const H = (a) => {
  const e = b({}, a);
  let { data: n, withXSRFToken: r, xsrfHeaderName: d, xsrfCookieName: f, headers: o, auth: t } = e;
  if (e.headers = o = S.from(o), e.url = g(w(e.baseURL, e.url, e.allowAbsoluteUrls), a.params, a.paramsSerializer), t && o.set(
    "Authorization",
    "Basic " + btoa((t.username || "") + ":" + (t.password ? unescape(encodeURIComponent(t.password)) : ""))
  ), m.isFormData(n)) {
    if (i.hasStandardBrowserEnv || i.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (m.isFunction(n.getHeaders)) {
      const s = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(s).forEach(([p, l]) => {
        c.includes(p.toLowerCase()) && o.set(p, l);
      });
    }
  }
  if (i.hasStandardBrowserEnv && (r && m.isFunction(r) && (r = r(e)), r || r !== !1 && u(e.url))) {
    const s = d && f && h.read(f);
    s && o.set(d, s);
  }
  return e;
};
export {
  H as default
};
//# sourceMappingURL=index.es357.js.map
